// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025
const DailyCollectionReportActionTypes = {
	/***************** GET DAILY COLLECTION REPORT LIST START ************* */
	GET_DAILY_COLLECTION_REPORT_LIST_START: 'get_daily_collection_report_start',
	GET_DAILY_COLLECTION_REPORT_LIST_SUCCESS: 'get_daily_collection_report_success',
	GET_DAILY_COLLECTION_REPORT_LIST_FAILURE: 'get_daily_collection_report_failure',
	GET_DAILY_COLLECTION_REPORT_LIST_RESPONSE_RESET: 'get_daily_collection_report_response_reset',
	GET_DAILY_COLLECTION_REPORT_LIST_RESPONSE_CHANGED:
		'get_daily_collection_report_response_changed',
	/***************** GET DAILY COLLECTION REPORT LIST END ************* */
};

export default DailyCollectionReportActionTypes;
